"use strict";

exports.__esModule = true;
exports.applyTrailingSlashOption = void 0; // TODO(v5): Remove legacy setting and default to "always"

var applyTrailingSlashOption = function applyTrailingSlashOption(input) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "legacy";
  var hasHtmlSuffix = input.endsWith(".html");
  var hasXmlSuffix = input.endsWith(".xml");
  var hasPdfSuffix = input.endsWith(".pdf");
  if (input === "/") return input;

  if (hasHtmlSuffix || hasXmlSuffix || hasPdfSuffix) {
    option = "never";
  }

  if (option === "always") {
    return input.endsWith("/") ? input : "".concat(input, "/");
  }

  if (option === "never") {
    return input.endsWith("/") ? input.slice(0, -1) : input;
  }

  return input;
};

exports.applyTrailingSlashOption = applyTrailingSlashOption;